module.exports = __webpack_public_path__ + "img/living-house.9b4d1de4.svg";